import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loader from "../components/Layout/Loader";

const ProtectedAdminRoute = ({ children }) => {
  const { loading, isAuthenticated, user } = useSelector((state) => state.user);
  
  // Show loader while checking authentication
  if (loading === undefined || loading === true) {
    return <Loader />;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  if (user?.role !== "Admin") {
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default ProtectedAdminRoute;
